import { Directive, HostListener, Input } from '@angular/core';
import { InputMaskDirective, InputmaskOptions } from '@ngneat/input-mask';

/**
 * Looks like Input mask has a bug where it wont send Paste Events to Angular Reactive Forms -
 * so validation will not be updated - this is a workaround to fire a synthetic input event on pate
 * to kick the validation into gear
 */
@Directive({
  standalone: true,
  selector: '[appInputMask]',
})
export class AppInputMaskDirective<T> extends InputMaskDirective<T> {
  @Input()
  public set appInputMask(inputMask: InputmaskOptions<T> | null | undefined) {
    super.inputMask = inputMask;
  }

  @HostListener('paste', ['$event'])
  public onPaste(e: ClipboardEvent) {
    setTimeout(() => {
      (e.target as HTMLInputElement).dispatchEvent(
        new Event('input', {
          bubbles: true,
        }),
      );
    });
  }
}
